"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUISINES = void 0;
const olympus_1 = require("olympus");
/** @deprecated Please use OlympusConstants.partner.CUISINES */
const CUISINES = olympus_1.OlympusConstants.partner.CUISINES;
exports.CUISINES = CUISINES;
exports.default = { CUISINES };
//# sourceMappingURL=cuisines.js.map